import { Injectable } from '@angular/core';

/**
 * 記入途中でタブを閉じる・リロードするなどの操作で入力値が失われるのを防ぐため、
 * ブラウザの離脱確認ダイアログを表示する beforeunload ハンドラを管理する。
 *
 * アプリ側から意図的にリロードする場合は独自の確認ダイアログで同意を得ているため、
 * ブラウザの離脱確認が重ねて表示されないよう {@link reloadWithoutConfirmation} を使う。
 */
@Injectable({
    providedIn: 'root',
})
export class UnloadGuardService {
    private readonly handleBeforeUnload = (event: BeforeUnloadEvent): void => {
        event.preventDefault();
        event.returnValue = '';
    };

    /** 離脱時にブラウザの確認ダイアログを表示するようにする */
    enable(): void {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    /** 離脱時にブラウザの確認ダイアログを表示しないようにする */
    disable(): void {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    /** ブラウザの離脱確認を表示せずにリロードする（アプリ側で確認済みの場合に使う） */
    reloadWithoutConfirmation(): void {
        this.disable();
        location.reload();
    }
}
